import { render, staticRenderFns } from "./border_all.vue?vue&type=template&id=5b98fb19"
import script from "./border_all.vue?vue&type=script&lang=js"
export * from "./border_all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports